'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import clsx from 'clsx';
interface CollectionDetailLinkProps {
  id: string;
  children: React.ReactNode;
  className?: string;
}
export default function CollectionDetailLink(t0) {
  const $ = _c(7);
  const {
    id,
    children,
    className
  } = t0;
  const t1 = !className && "text-sm font-medium text-primary-600 hover:text-primary-700 flex items-center gap-1";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = clsx(t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `/collections/${id}`;
  let t4;
  if ($[3] !== children || $[4] !== t2 || $[5] !== t3) {
    t4 = <Link className={t2} href={t3}>{children}</Link>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}